import type {
  BuildStepArgs,
  SourceTree,
} from '@divriots/studio-compiler-support';

function escape(uce) {
  return uce.replace('`', '\\`');
}

function transform(uce: string): string {
  return `import "uce-template";

const template = \`${escape(uce)}\`;

customElements
  .whenDefined("uce-template")
  .then((Template) =>
    document.body.insertAdjacentElement("beforeend", Template.from(template))
  );
`;
}

export async function compile({
  input,
  registry,
  tree,
}: BuildStepArgs): Promise<SourceTree> {
  let output: SourceTree = {};
  for (const file in input) {
    output['dist/' + file.slice(4) + '.js'] = transform(input[file]);
  }
  return output;
}
